<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :md="6" :sm="12">
            <a-form-item label="租户名称">
              <j-input placeholder="输入租户名称模糊查询" v-model="queryParam.name"></j-input>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item label="状态">
              <a-select v-model="queryParam.status" placeholder="请选择状态">
                <a-select-option value="">请选择</a-select-option>
                <a-select-option value="1">启用</a-select-option>
                <a-select-option value="0">停用</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>              
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator" style="border-top: 5px">
      <a-button @click="handleAdd" type="primary" icon="plus">添加租户</a-button>      
      <!--<j-super-query :fieldList="superQueryFieldList" @handleSuperQuery="handleSuperQuery"/>-->
    </div>

    <!-- table区域-begin -->
    <div>     

      <a-table
        ref="table"
        bordered
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange">

        <!-- <template slot="avatarslot" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <a-avatar shape="square" :src="getAvatarView(record.avatar)" icon="user"/>
          </div>
        </template> -->

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical"/>

          <a-dropdown>
            <a class="ant-dropdown-link">
              更多 <a-icon type="down"/>
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a href="javascript:;" @click="handleDetail(record)">详情</a>
              </a-menu-item>              

              <a-menu-item v-if="record.status==1">
                <a-popconfirm title="确定停用吗?" @confirm="() => enableTenant(record.id,0)">
                  <a>停用</a>
                </a-popconfirm>
              </a-menu-item>

              <a-menu-item v-if="record.status==0">
                <a-popconfirm title="确定启用吗?" @confirm="() => enableTenant(record.id,1)">
                  <a>启用</a>
                </a-popconfirm>
              </a-menu-item>

              <a-menu-item>
                <a-popconfirm title="确定发送账号到租户邮箱吗?" @confirm="() => sendAccount(record.id)">
                  <a>发送账号</a>
                </a-popconfirm>
              </a-menu-item>

            </a-menu>
          </a-dropdown>
        </span>


      </a-table>
    </div>
    <!-- table区域-end -->

    <tenant-modal ref="modalForm" @ok="modalFormOk"></tenant-modal>
  </a-card>
</template>

<script>
  import TenantModal from './modules/TenantModal'
  import {putAction,getFileAccessHttpUrl} from '@/api/manage';
  import {enableTenant,sendAccountToEmail} from '@/api/api'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import UserRecycleBinModal from './modules/UserRecycleBinModal'
  import JInput from '@comp/jeecg/JInput'

  export default {
    name: "TenantList",
    mixins: [JeecgListMixin],
    components: {
      JInput,
      TenantModal,
      UserRecycleBinModal
    },
    data() {
      return {
        description: '这是租户管理页面',
        queryParam: {},
        recycleBinVisible: false,
        columns: [
          /*{
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },*/
          {
            title: '租户名称',
            align: "center",
            dataIndex: 'name',
            width: 180,
            // sorter: true
          },
          {
            title: '联系人',
            align: "center",
            width: 80,
            dataIndex: 'contacts',
          },
          {
            title: '电话',
            align: "center",
            width: 100,
            dataIndex: 'phone',
          },

          {
            title: '状态',
            align: "center",
            width: 80,
            dataIndex: 'status_dictText',
          },
          {
            title: '开始时间',
            align: "center",
            width: 120,
            dataIndex: 'beginTime_formatText'
          },
          {
            title: '截止时间',
            align: "center",
            width: 120,
            dataIndex: 'endTime_formatText'
          },
          {
            title: '限制队列数量',
            align: "center",
            width: 80,
            dataIndex: 'projectLimit'
          },
          {
            title: '限制中心数量',
            align: "center",
            width: 80,
            dataIndex: 'centerLimit'
          },
          {
            title: '机构名称',
            align: "center",
            width: 220,
            dataIndex: 'orgName'
          },
          {
            title: '操作',
            dataIndex: 'action',
            scopedSlots: {customRender: 'action'},
            align: "center",
            width: 120
          }

        ],
        url: {
          list: "/sys/tenant/list",
        },
      }
    },
    computed: {
    },
    methods: {      
      enableTenant: function (id, status) {
        let that = this;
        
        enableTenant({id: id, status: status}).then((res) => {
          if (res.success) {
            that.$message.success(res.message);
            that.loadData();
          } else {
            that.$message.warning(res.message);
          }
        });
      },

      sendAccount: function(id){
        let that = this;
        
        sendAccountToEmail({id: id}).then((res) => {
          if (res.success) {
            that.$message.success(res.message);
            // that.loadData();
          } else {
            that.$message.warning(res.message);
          }
        });
      },
    }

  }
</script>
<style scoped>
  @import '~@assets/less/common.less'
</style>
